const dataTypePattern = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^1\d{10}$/,
  otherPhone: /^\d{6,14}$/,
  number: /^[+-]?\d+(\.\d+)?$/
}
import { mapActions } from 'vuex'
import Actions from '@/constants/action'
import { addZero } from '@/util'
import { upload } from '@/mixin/file'
import SchoolListZh from './school_zh.json'
import SchoolListEn from './school_en.json'
import { http } from '@/api'
import { PublicEvent } from '@/api/collection'
import { dialog } from 'vant'
export default {
  data() {
    return {
      questionList: [],
      lastHides: {},
      isUserexist: false,
      hiddenSubmitBtn: false,
      school_zh: SchoolListZh.list.sort(),
      school_en: SchoolListEn.list.sort(),
      phoneNo: '',
      // comeFromPhoneBlur: true
    }
  },
  mixins: [upload],
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    delay: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {}
    },
    fileKeys: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    'data.Questions': {
      handler(val) {
        this.questionList = val && val.filter(item => !item.hidden)
        this.hiddenSubmitBtn = !(val && val.find(item => item.type !== 'image' && item.type !== 'section'))
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resetValidate()
    })
  },
  methods: {
    async uploaded(files, item) {
      if (files.length > 0) {
        this.formData[item.key] = []
        const res = await this.uploadToSys(files.map(item => item.file))
        this.formData[item.key] = this.formData[item.key].concat(res.data)
      } else {
        this.formData[item.key] = []
      }
      this.validField(item, null)
    },
    ...mapActions({
      checkUserExist: Actions.CHECK_USER_EXIST
    }),
       // 检查是否已报名活动
    async checkLeadIsRegistered(data){
        const res = await http({
          path: PublicEvent.CheckLeadIsRegistered.path,
          method: PublicEvent.CheckLeadIsRegistered.method,
          data
        })
        if(res.resultCode === '0' ){
            if(res.data === true){ // true表示已报名
              dialog.alert({
                message: '您已提交过报名，请勿重复报名'
              }).then(() => {       
                  this.$emit('applyStatus', '0')  // 0已报名过活动    
                  this.$parent.$parent.showThanksPage(true)
                  this.$emit('submited',true)
              }).catch(() => {
                // cancel return, do nothing
              })            
            }
        }
    },
    toDetail(item) {
      if (item.type === 'section') {
        return (item.meta.defaultValue || '').split('\n').join('<br>').trim()
      }
      return ''
    },
    formatText(item) {
      if (item.type === 'text') {
        if (item.meta.defaultValue.startsWith('This')) {
          return item.label
        }
        return item.meta.defaultValue
      }
      return ''
    },
    sortingChange(item) {
      this.$nextTick(() => {
        this.formData[item.key] = []
        item.options.forEach((it, ind) => {
          const ans = addZero(ind) + '#' + it.id
          this.formData[item.key].push(ans)
        })
      })
    },
    async checkPhone(item, now) {
      // if (item.default === 'PHONE' && this.formData[item.key].length > 7 && (item.text || now)) {
      //   const res = await this.checkUserExist({
      //     contryCode: item.meta.countryCode,
      //     phoneNo: this.formData[item.key]
      //   })
      //   this.isUserexist = res.data.isPhoneNoExist
      //   this.data.Questions.forEach(item => {
      //     if (item.default && item.default !== 'PHONE' && this.isUserexist) {
      //       this.$set(item, 'alwaysHidden', true)
      //     }
      //   })
      // }
    },
    checkNextShow(current, index) {
      let next = ''
      let nextOne = null
      // 当前的值
      const value = this.formData[current.key]
      // 当前有值才继续
      if (value) {
        // 如果是 radio 和 select 先根据 value 查找多个 next
        if (current.type === 'radio' || current.type === 'select') {
          const obj = current.options.find(op => op.defaultId === value || op.id === value)
          next = obj.next || ''
        }
        // 如果找到next 为空则取当前默认的 next
        next = next || current.next
        // 如果 next 为空 并 判断当前不是最后一个, 则取当前的下一个
        if (!next) {
          nextOne = this.data.Questions.find(item => current.order === item.order)
        } else {
          // next 存在的话, 循环找到 nextOne
          this.data.Questions.forEach(item => {
            if (item.key === next) {
              nextOne = item
            }
          })
        }
        if (nextOne) {
          // const mustShow = [current, nextOne] // 必须显示的题目
          // findAllNextOne(nextOne, this.data.Questions, mustShow)
          // 如果找到下一个题目, 当nextOne 为radio或者select时递归找到后面都活着(一定要显示)的题目
          // mustShow.forEach(v => {
          //   this.$set(v, 'hidden', false)
          // })
          if (this.lastHides[current.id]) {
            this.lastHides[current.id].forEach(v => {
              this.$set(v, 'hidden', false)
            })
          }
          this.lastHides[current.id] = this.lastHides[current.id] ? this.lastHides[current.id] : []
          this.data.Questions.forEach(item => {
            // 将当前和下一个之间的题目隐藏
            if (item.order > current.order && item.order < nextOne.order) {
              this.$set(item, 'hidden', true) // 之间的先隐藏
              this.lastHides[current.id].push(item)
              // 隐藏值清空
              if (item.type === 'checkbox') {
                this.$set(this.formData, item.key, item.meta.defaultValue || [])
              } else if (item.type === 'checkboxInput') {
                this.$set(this.formData, item.key, item.meta.defaultValue || [])
              } else if (item.type === 'sorting') {
                this.$set(this.formData, item.key, item.meta.defaultValue ||
                  item.options.map((it, ind) => {
                    return addZero(ind) + '#' + it.id
                  }))
              } else if (item.type === 'rate' || item.type === 'number') {
                this.$set(this.formData, item.key, item.meta.defaultValue || 0)
              } else {
                this.$set(this.formData, item.key, item.meta.defaultValue || '')
              }
              if (item.type === 'select') {
                this.$set(item, 'text', item.meta.defaultValue || '')
              }
              this.resetValidate()
              // 将大于下一个的题目全部显示
            } else if (item.order >= nextOne.order) {
              this.$set(item, 'hidden', false)
            }
          })
        }
      } else {
        // 没值的话,复原, 将当前以后的全部显示出来
        this.data.Questions.forEach(item => {
          if (item.order >= current.order) {
            this.$set(item, 'hidden', false)
          }
        })
      }
    },
    getNumId(str) {
      return Number(str.substr(1, str.length - 1) || '')
    },
    validField(item, val) {
      this.$nextTick(() => {
        if (
          this.validate[item.key] !== undefined &&
          this.formData[item.key] !== undefined
        ) {
          if (this.formData[item.key] instanceof Array) {
            if (this.formData[item.key].length > 0) {
              this.$nextTick(()=>{
                this.$set(this.validate, item.key, false)
              })
              if (this.formData[item.key].find(i => { return i.endsWith('Other') }) && item.type !== 'sorting') {
                if (this.formData[item.key + 'Other']) {
                  this.$nextTick(()=>{
                    this.$set(this.validate, item.key + 'Other', false)
                  })
                } else {
                  this.$nextTick(()=>{
                    this.$set(this.validate, item.key + 'Other', true)
                  })
                }
              }
            } else {
              this.$nextTick(()=>{
                this.$set(this.validate, item.key, true)
              })
            }
          } else if (typeof this.formData[item.key] === 'string') {
            if (this.fileKeys.includes(item.key)) {
              if (this.tempFiles[item.key]) {
                this.$set(this.validate, item.key, false)
              } else {
                this.$set(this.validate, item.key, true)
              }
            } else {
              if (this.formData[item.key]) {
                // 有值也要判断是否符合正则
                if (Object.keys(dataTypePattern).includes(item.meta.dataType)) {
                  if (item.meta.dataType === 'phone') {
                    if (item.meta.countryCode === 86) {
                      this.$set(
                        this.validate,
                        item.key,
                        !dataTypePattern[item.meta.dataType].test(
                          this.formData[item.key]
                        )
                      )
                      this.$set(
                        this.validateMsg,
                        item.key,
                        '请输入正确的' + item.label
                      )
                    } else {
                      this.$set(
                        this.validate,
                        item.key,
                        !dataTypePattern['otherPhone'].test(
                          this.formData[item.key]
                        )
                      )
                      this.$set(
                        this.validateMsg,
                        item.key,
                        '请输入正确的' + item.label
                      )
                    }
                  } else {
                    this.$set(
                      this.validate,
                      item.key,
                      !dataTypePattern[item.meta.dataType].test(
                        this.formData[item.key]
                      )
                    )
                    this.$set(
                      this.validateMsg,
                      item.key,
                      '请输入正确的' + item.label
                    )
                  }
                } else if (item.meta.dataType === 'custom') {
                  this.$set(
                    this.validate,
                    item.key,
                    !((new RegExp(item.meta.pattern.replaceAll('/', ''))).test(
                      this.formData[item.key]
                    ))
                  )
                  this.$set(
                    this.validateMsg,
                    item.key,
                    '请输入正确的' + item.label
                  )
                } else {
                  this.$set(this.validate, item.key, false)
                  this.$set(this.validateMsg, item.key, '请输入此项')
                }
                // 检查是否是: 其他
                if (this.formData[item.key].endsWith('Other')) {
                  if (this.formData[item.key + 'Other']) {
                    this.$set(this.validate, item.key + 'Other', false)
                  } else {
                    this.$set(this.validate, item.key + 'Other', true)
                  }
                } else {
                  this.$set(this.validate, item.key + 'Other', false)
                }
              } else if (this.formData[item.key] === '' && item.required) {
                this.$set(this.validate, item.key, true)
                this.$set(this.validateMsg, item.key, '请输入此项')
              } else {
                this.$set(this.validate, item.key, true)
              }
            }
          }
        }
      })
    },
    validateForm() {
      Object.keys(this.formData).forEach(key => {
        if (
          this.validate[key] !== undefined &&
          this.formData[key] !== undefined
        ) {
          if (this.formData[key] instanceof Array) {
            if (this.formData[key].length > 0) {
              this.$set(this.validate, key, false)
              const Qh = this.questionList.find(q => q.key === key)
              if (this.formData[key].find(item => { return item.endsWith('Other') }) && Qh.type !== 'sorting') {
                if (this.formData[key + 'Other']) {
                  this.$set(this.validate, key + 'Other', false)
                } else {
                  this.$set(this.validate, key + 'Other', true)
                }
              }
            } else {
              this.$set(this.validate, key, true)
            }
          } else if (typeof this.formData[key] === 'string') {
            if (this.fileKeys.includes(key)) {
              // 文件类型
              if (this.tempFiles[key]) {
                this.$set(this.validate, key, false)
              } else {
                this.$set(this.validate, key, true)
              }
            } else {
              if (this.formData[key]) {
                // 有值也要判断是否符合正则
                this.questionList.forEach(Q => {
                  if (Q.key === key) {
                    if (Object.keys(dataTypePattern).includes(Q.meta.dataType)) {
                      if (Q.meta.dataType === 'phone') {
                        if (Q.meta.countryCode === 86) {
                          this.$set(
                            this.validate,
                            key,
                            !dataTypePattern[Q.meta.dataType].test(
                              this.formData[key]
                            )
                          )
                          this.$set(
                            this.validateMsg,
                            key,
                            '请输入正确的' + Q.label
                          )
                        } else {
                          this.$set(
                            this.validate,
                            key,
                            !dataTypePattern['otherPhone'].test(
                              this.formData[key]
                            )
                          )
                          this.$set(
                            this.validateMsg,
                            key,
                            '请输入正确的' + Q.label
                          )
                        }
                      } else if (Q.meta.dataType === 'custom') {
                        this.$set(
                          this.validate,
                          Q.key,
                          !((new RegExp(Q.meta.pattern.replaceAll('/', ''))).test(
                            this.formData[Q.key]
                          ))
                        )
                        this.$set(
                          this.validateMsg,
                          Q.key,
                          '请输入正确的' + Q.label
                        )
                      } else {
                        this.$set(
                          this.validate,
                          key,
                          !dataTypePattern[Q.meta.dataType].test(
                            this.formData[key]
                          )
                        )
                        this.$set(
                          this.validateMsg,
                          key,
                          '请输入正确的' + Q.label
                        )
                      }
                    } else {
                      this.$set(this.validate, key, false)
                      this.$set(this.validateMsg, key, '请输入此项')                   
                    }
                    // 检查是否是: 其他
                    if (this.formData[key].endsWith('Other')) {
                      if (this.formData[key + 'Other']) {
                        this.$set(this.validate, key + 'Other', false)
                      } else {
                        this.$set(this.validate, key + 'Other', true)
                      }
                    } else {
                      this.$set(this.validate, key + 'Other', false)
                    }
                  }
                })
              } else if (!key.endsWith('Other') && !this.formData[key]) {
                this.$set(this.validate, key, true)              
              }
            }
          }
          this.data.Questions.forEach(q => {
            if (q.hidden && q.key === key) {
              this.$set(this.validate, key, false)
            }
          })
        }
      })
      const res = Object.values(this.validate).some(key =>key)
      if(res){
        this.$message.error('请检查信息是否填写完整！')
      }
    },
    resetValidate() {
      Object.keys(this.validate).forEach(key => {
        this.$set(this.validate, key, false)
      })
      this.$refs.form && this.$refs.form.resetValidation()
    },
    initNextShow() {
      this.questionList.forEach((item, index) => {
        if (!item.hidden) {
          this.checkNextShow(item, index)
        }
      })
    },
    reduceArr(arr){
      let items = []
      for(var i in arr){
          if(items.indexOf(arr[i]) == -1){
              items.push(arr[i])
          }
      }
      return items
    },
  }
}
